import React from "react";
import { Dialog, DialogProps as MUIDialogProps } from "@mui/material";
import { create, muiDialogV5, useModal } from "@ebay/nice-modal-react";
import Button from "../Button/Button";
import css from "./ConfirmModal.module.scss";
import { CloseIcon, RedCircleIcon, TrashIcon } from "Assets/index";

type Props = Omit<MUIDialogProps, "onClick"> & {
  onClick: () => void;
  isSimpleModal?: boolean;
  description?: string;
  confirmBtnTitle?: string;
  icon?: React.ReactNode;
  isFuncLoading?: boolean;
};

const ConfirmModal = create<Props>(
  ({
    onClick,
    isSimpleModal,
    isFuncLoading,
    description = "Are you sure you want to delete?",
    confirmBtnTitle = "Delete",
    icon = <TrashIcon />,
    ...props
  }) => {
    const modal = useModal();
    return (
      <Dialog
        {...muiDialogV5(modal)}
        {...props}
        classes={{
          paper: css.container,
        }}
      >
        <div className={css.content}>
          {!isSimpleModal && (
            <div className={css["action-icon"]}>
              <RedCircleIcon className={css.circle} />
              {icon}
            </div>
          )}
          <div className={css["close-icon"]}>
            <CloseIcon onClick={() => modal.hide()} />
          </div>
          <p className={css.title}>{description}</p>

          <div className={css.actions}>
            <Button onClick={modal.hide} color="secondary">
              Cancel
            </Button>

            {/* The icon variant confirms a destructive action (delete by default). */}
            <Button
              isFuncLoading={isFuncLoading}
              onClick={onClick}
              color={isSimpleModal ? "primary" : "error"}
            >
              {confirmBtnTitle}
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
);

export default ConfirmModal;
